import React, { useState, useEffect } from 'react';
import { Typography, Form, Input, Button, Space, Alert, Spin, Card, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { getCurrentUser } from '../services/authService';
import { getUserProfile, updateUserProfile } from '../services/userService';
import { uploadImage } from '../services/uploadService';

const { Title } = Typography;

function ProfilePage() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const user = await getCurrentUser();
      if (user) {
        const profile = await getUserProfile(user.id);
        form.setFieldsValue({
          username: profile.username,
          image_url: profile.image_url,
        });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async values => {
    try {
      const user = await getCurrentUser();
      if (user) {
        await updateUserProfile(user.id, values);
        message.success('Profile updated successfully');
      }
    } catch (err) {
      setError(err.message);
      message.error(err.message);
    }
  };

  const handleImageUpload = async file => {
    try {
      const imageUrl = await uploadImage(file);
      form.setFieldValue('image_url', imageUrl);
      return false; // Prevent default upload behavior
    } catch (err) {
      message.error('Failed to upload image');
      return false;
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return <Alert message={error} type="error" />;
  }

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Profile Settings</Title>
      <Card style={{ maxWidth: 600, margin: '24px auto' }}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="username"
            label="Username"
            rules={[{ required: true, message: 'Please enter your username' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item name="image_url" label="Profile Image">
            <Space direction="vertical" style={{ width: '100%' }}>
              {form.getFieldValue('image_url') && (
                <img
                  src={form.getFieldValue('image_url')}
                  alt="Profile"
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                />
              )}
              <Input />
              <Upload beforeUpload={handleImageUpload} maxCount={1} showUploadList={false}>
                <Button icon={<UploadOutlined />}>Upload Image</Button>
              </Upload>
            </Space>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default ProfilePage;
